import React from 'react'

export interface RailsContextInterface {
  // maybe type because the values get injected after context creation
  env?: {
    REACT_APP_GOOGLE_MAPS_API_KEY: string
    REACT_APP_RECAPTCHA_KEY: string
  }
  railsEnv?: 'test' | 'development' | 'production'
  serverSide?: boolean
  location?: string
  embedded?: boolean
}

const RailsContext: React.Context<RailsContextInterface> = React.createContext(
  {}
)

export default RailsContext
